module.exports = __webpack_public_path__ + "img/35fr.6c17d162.png";